import { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';

const useCognitoUser = () => {
  const [userInfo, setUserInfo] = useState('');

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const currentUser = await Auth.currentAuthenticatedUser();
        const userInfo = {
          username: currentUser?.attributes.name,
          email: currentUser?.attributes.email,
          id: currentUser?.attributes.sub,
          verified: currentUser?.attributes.email_verified,
          group: currentUser?.signInUserSession.idToken?.payload["cognito:groups"]?.at(0) || undefined,
        }
        setUserInfo(userInfo);
      } catch (error) {
        console.error('Error fetching user: ', error);
      }
    };

    fetchUserInfo();
  }, []);

  return userInfo;
};

export default useCognitoUser;
export { useCognitoUser };